<template>
  <section class="swiper band" :key="sectionInfo.title + '_commonBand'" v-if="isLoaded && isVisible" :style="getColor">
    <div>
      <template v-if="isSearch">
        <div class="band-title-wrap">
          <h1 v-if="cellList.length !== 0" class="band-title" tabindex="0" v-band-title v-html="sectionInfo.title"></h1>
          <span class="search-result-number" v-if="hasCount" :aria-label="'검색 결과 ' + sectionInfo.count + '건'">{{sectionInfo.count}}</span>
        </div>
      </template>
      <template v-else-if="!hasButtonInfo">
        <div class="band-title-wrap">
          <h1 class="band-title" tabindex="0" v-band-title>{{sectionInfo.title}}</h1>
        </div>
      </template>
      <loadingBand :cell-type="sectionInfo.cellType" :is-loading="loading"
                    :container-class-name="getCellListContainerClassName"
      />
    <cellList v-if="cellList && cellList.length"
        :cell-list="cellList"
        :thumbnail-info="thumbnailInfo"
        :container-class-name="getCellListContainerClassName"
        :bottom-tab="bottomTab"
        :is-bg-color="sectionInfo.bgColor"
      @cell-click-log="sendCellClickLog"
    />

      <!-- D: 검색 결과 밴드-->
      <a href="#" v-if="isSearch && sectionInfo.hasViewMore" @click.prevent="()=>moveToTab(sectionInfo)" class="link-band-list search-result" :aria-label="'검색 결과 ' + sectionInfo.count + '건 모두보기'">{{sectionInfo.count}}</a>

      <!-- D: 일반 밴드-->
      <view-more v-if="hasViewMore" :route-to-list-fn="routeToList" :view-more-title="sectionInfo.title"></view-more>

      <div v-else-if="cellList.length === 0 && isMy" class="component-container">
        <div class="my-no-data">
          <empty-icon />
          <span class="my-no-data-txt" v-band-title>{{hasNotCellListText}}</span>
        </div>
      </div>
      <ppv-wrapper v-if="hasButtonInfo" :button-info="buttonInfo"></ppv-wrapper>
    </div>
  </section>
</template>

<script>
import { getBandTypeInfoByCellType, getCellListContainerClassName } from '@/common/image.util'
import { get, replace } from 'lodash'
import { bandTitle } from '@/common/directives'
import { parseUrl, stringify } from 'query-string'
import LoadingBand from '@/components/section/template/LoadingBand'
import EventModelClass from '@/common/model/EventModelClass'
import CellList from '@/components/section/template/cell/CellList'
import { FETCH_BAND_INFO } from '@/store/types/actions.type'
import { mapActions } from 'vuex'
import store from '@/store'
import { getTypeCodeFromTitleString, hasViewMore, viewMoreTitle, routeToList } from '@/common/util/common'
import PpvWrapper from '@/components/section/template/wrapper/PpvWrapper'
import EmptyIcon from '@/assets/svg/common/img_empty.svg'
import ViewMore from '@/components/section/template/viewmore/ViewMore'
import { MY_EMPTY_MESSAGE_LIST } from '@/common/constant'
import { SearchService } from '@/common/api/api.service'
import {
  PATH_NAME_SEARCH,
  PATH_NAME_SEARCH_TAG,
  PATH_NAME_SEARCH_TAG_GROUP
} from '@/common/router.const'
import {
  sendEventLogSearchCell,
  sendEventLogSearchResultThemeViewAll,
  sendEventLogSearchResultViewAll
} from '@/common/util/log.v2.send'

export default {
  name: 'CommonBand',
  components: {
    ViewMore,
    PpvWrapper,
    CellList,
    LoadingBand,
    EmptyIcon
  },
  directives: { bandTitle },
  props: ['sectionInfo', 'bottomTab'],
  data () {
    return {
      isTagSearchGroupView: false,
      isTagSearchView: false,
      isKeywordSearchView: false,
      isLoaded: false,
      isVisible: true,
      loading: true,
      genTime: '',
      cellList: [],
      thumbnailInfo: {},
      buttonInfo: null,
      forceRefresh: false,
      isMy: get(this.$route, 'name', '') === 'my'
    }
  },
  methods: {
    ...mapActions({ fetchBandData: FETCH_BAND_INFO }),
    getMemorizeKey (viewMoreEvent) {
      const { url, query } = parseUrl(viewMoreEvent.url)
      if (this.$route.name === 'search' || this.$route.name === 'my') {
        return url.split('/').pop()
      } else {
        return query.uitype
      }
    },
    routeToList () {
      routeToList(this.sectionInfo, this.$route)
    },
    moveToTab (sectionInfo) {
      // todo: 22/10/17 pc 와 동일 한 구조 (sendRouter) 리팩토링 할 필요가 있는지 체크 -> 로그 전송 후 라우터 푸시
      const sectionTitle = sectionInfo.title === '에피소드' ? 'VOD' : sectionInfo.title
      const type = getTypeCodeFromTitleString(sectionTitle)
      const mType = type === 'movie' ? sectionTitle === '영화플러스' ? 'ppv' : 'svod' : 'all'
      if (this.isTagSearchView || this.isTagSearchGroupView) {
        const routeName = this.isTagSearchView ? PATH_NAME_SEARCH_TAG : PATH_NAME_SEARCH_TAG_GROUP
        let query = {
          type: type,
          searchCategory: type,
          mType: mType,
          url: get(sectionInfo, 'viewMoreEvent.url', ''),
          tagList: get(sectionInfo, 'viewMoreEvent.bodyList', '')
        }
        if (this.isTagSearchGroupView) {
          query = Object.assign(query, get(this.$route, 'query', {}))
        }
        sendEventLogSearchResultViewAll({
          contentType: `${type}${mType}`,
          routeName: routeName,
          landingUrl: `${routeName}?${stringify(query)}`
        })
        this.$router.push({
          name: this.isTagSearchView ? PATH_NAME_SEARCH_TAG : PATH_NAME_SEARCH_TAG_GROUP,
          query
        })
      } else {
        const isThemeBand = get(sectionInfo, 'contentEvent.url', '').indexOf('theme') > -1
        const themeId = (get(sectionInfo, 'contentEvent.url', '').match(/(themes-band\/)(\w+)/gi) || []).join().replaceAll('themes-band/', '')
        const routeQuery = {
          searchCategory: isThemeBand ? 'theme-list' : type,
          searchWord: get(this.$route, 'query.searchWord', ''),
          mType: mType,
          url: get(sectionInfo, 'viewMoreEvent.url', '')
        }

        isThemeBand
          ? sendEventLogSearchResultThemeViewAll({ themeId: themeId, routeQuery: this.$route.query, landingUrl: `${PATH_NAME_SEARCH}?${stringify(routeQuery)}` })
          : sendEventLogSearchResultViewAll({ contentType: isThemeBand ? 'theme' : `${type}${mType}`, routeName: this.$route.name, landingUrl: `${PATH_NAME_SEARCH}?${stringify(routeQuery)}` })

        this.$router.push({
          name: PATH_NAME_SEARCH,
          query: routeQuery
        })
      }
    },
    getVisibleState () {
      if (this.isMy) {
        this.isVisible = true
      } else if (this.cellList.length === 0) {
        this.isVisible = false
      }
    },
    getSearchTagData () {
      const bodyListData = JSON.parse(get(this.sectionInfo, 'contentEvent.bodyList.0', ''))
      SearchService.tagSearchBand({
        url: get(this.sectionInfo, 'contentEvent.url'),
        searchtags: get(bodyListData, 'searchtags', [])
      }).then(({ data }) => {
        if (get(data, 'gen_time', '') !== this.genTime || get(data, 'gen_time', '') === null) {
          this.genTime = get(data, 'gen_time', null)
          this.cellType = get(data, 'band.cell_type', null)
          this.cellList = get(data, 'band.celllist', [])
          this.getVisibleState()
        }
        this.isLoaded = true
        this.loading = false
      })
    },
    setData () {
      let memorize = this.hasMemorize
      if (memorize) {
        this.genTime = memorize.genTime
        this.cellType = memorize.cellType
        this.cellList = memorize.cellList
        this.buttonInfo = memorize.buttonInfo
        this.getVisibleState()
        this.isLoaded = true
        this.loading = false
      }
      if (this.isTagSearchView || this.isTagSearchGroupView) {
        this.getSearchTagData()
      } else {
        this.fetchBandData(
          { eventModel: new EventModelClass(this.sectionInfo.contentEvent),
            force: this.sectionInfo.forceRefresh }).then((response) => {
          if (this.genTime !== response.genTime || response.genTime === null) {
            this.genTime = response.genTime
            this.cellType = response.cellType
            this.cellList = response.cellList
            this.buttonInfo = response.buttonInfo
            this.getVisibleState()
          }
          this.isLoaded = true
          this.loading = false
        })
      }
      this.thumbnailInfo = getBandTypeInfoByCellType(this.sectionInfo.cellType)
    },
    changeColorSearchWord (title) {
      const searchWord = get(this.$route, 'query.searchWord', '')
      return replace(title, new RegExp(searchWord, 'g'), `<span style="color:#3887ff">${searchWord}</span>`)
    },
    sendCellClickLog ({ cellInfo = {}, index = -1, routeName = '' }) {
      sendEventLogSearchCell({ cellInfo: cellInfo, index: index, routeName: routeName })
    }
  },
  computed: {
    getCellListContainerClassName () {
      let bgColor = this.sectionInfo.bgColor ? ' color' : ''
      return getCellListContainerClassName(this.thumbnailInfo.type) + bgColor
    },
    isSearch () {
      return this.isKeywordSearchView || this.isTagSearchView || this.isTagSearchGroupView
    },
    hasViewMore () {
      // 아폴로, 검색인 경우 더보기 비노출
      const routeNameList = [PATH_NAME_SEARCH_TAG, PATH_NAME_SEARCH_TAG_GROUP, PATH_NAME_SEARCH]
      if (routeNameList.indexOf(this.$route.name) > -1) {
        return false
      }
      return hasViewMore(this.sectionInfo)
    },
    hasMemorize () {
      return store.getters.hasMemorize(this.getMemorizeKey(this.sectionInfo.contentEvent))
    },
    hasCount () {
      return get(this.sectionInfo, 'count', '0') !== '0'
    },
    hasButtonInfo () {
      return this.buttonInfo !== null
    },
    getColor () {
      return 'background-color: transparent'
    },
    containerClass () {
      return this.buttonInfo === null
        ? this.sectionInfo.cellType === 'Band94'
          ? 'component-container ranking-band'
          : 'component-container'
        : 'component-container ppv-banner'
    },
    hasNotCellListText () {
      const emptyMessageList = MY_EMPTY_MESSAGE_LIST.filter((emptyMsg) =>
        get(emptyMsg, 'title', '') === get(this.sectionInfo, 'title', ''))
      return get(emptyMessageList, '0.message', '')
    },
    viewMoreTitle () {
      return viewMoreTitle(this.sectionInfo)
    }
  },
  mounted () {
    this.isTagSearchView = get(this.$route, 'name', '') === PATH_NAME_SEARCH_TAG
    this.isTagSearchGroupView = get(this.$route, 'name', '') === PATH_NAME_SEARCH_TAG_GROUP
    this.isKeywordSearchView = get(this.$route, 'name', '') === PATH_NAME_SEARCH
    this.setData()
  }
}
</script>
